import { useQuery } from '@tanstack/react-query'
import { useAuth } from '@/contexts/AuthContext'
import { supabase } from '@/lib/supabase'

/**
 * Hook to check if the current user is an admin (superuser).
 * Admin has all permissions on the platform (including moderator capabilities).
 * Checks both `role` and `user_type` in profiles table.
 */
export function useAdmin() {
  const { user } = useAuth()

  const { data: isAdmin } = useQuery({
    queryKey: ['is-admin', user?.id],
    queryFn: async () => {
      if (!user) return false

      const { data, error } = await supabase
        .from('profiles')
        .select('role, user_type')
        .eq('id', user.id)
        .maybeSingle()

      if (error) {
        console.warn('Error checking admin status:', error)
        return false
      }
      if (!data) return false

      const role = data?.role
      const userType = data?.user_type

      return role === 'admin' || userType === 'admin'
    },
    enabled: !!user,
    staleTime: 60000, // Cache for 1 minute
  })

  return isAdmin ?? false
}
